import { render, staticRenderFns } from "./LiveItemOther.vue?vue&type=template&id=43ba5a34&scoped=true&lang=pug&"
import script from "./LiveItemOther.vue?vue&type=script&lang=js&"
export * from "./LiveItemOther.vue?vue&type=script&lang=js&"
import style0 from "./LiveItemOther.scss?vue&type=style&index=0&id=43ba5a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ba5a34",
  null
  
)

export default component.exports